<template></template>

<script>
import anime from "animejs"

export default {
    name: 'headernav',

    data() {
        return {
            open: false,
            sticky: false,
            activeNavIndex: '',
            body: '',
            animation: '',
            animationCompleted: true,
            animationInterval: '',
        }
    },

    watch: {
        open: function (val) {
            if (val) {
                this.enableBodyScrollLock();
                this.triggerMenu();
            } else {
                this.disableBodyScrollLock();
                this.activeNavIndex = '';
            }
        },

        activeNavIndex: function (val) {
            clearInterval(this.animationInterval);
            this.animationInterval = null;

            this.animationInterval = setInterval(() => {
                if (this.animationCompleted) {
                    this.triggerItem(val);
                }
            }, 10);

        }
    },

    mounted() {
        const self = this;
        this.body = document.querySelector('body');
        let last_known_scroll_position = 0;
        let ticking = false;

        window.addEventListener("scroll", function () {
            last_known_scroll_position = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    if (last_known_scroll_position > 50) {
                        self.sticky = true;
                    } else {
                        self.sticky = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });
    },

    methods: {
        triggerMenu() {
            const navItems = this.$refs.nav.querySelectorAll('[data-nav-item]');
            navItems.forEach(item => {
                item.parentElement.style.overflow = 'hidden';
            });

            this.animation = anime.timeline({
                easing: 'easeOutQuad',
                complete: function () {
                    navItems.forEach(item => {
                        item.parentElement.style.overflow = 'visible';
                    });
                }
            });

            this.animation
                .add({
                    targets: this.$refs.bg,
                    scaleY: [0, 1],
                    duration: 400
                })
                .add({
                    targets: navItems,
                    translateY: ['100%', 0],
                    duration: 600,
                    delay: anime.stagger(75)
                }, 200)
                .add({
                    targets: this.$refs.defaultimage,
                    opacity: [0, 1],
                    rotate: ['-10deg', 0],
                    duration: 800
                }, 400)
                .add({
                    targets: this.$refs.nav.querySelectorAll('[data-social-item]'),
                    translateX: ['30px', 0],
                    opacity: [0, 1],
                    duration: 400,
                    delay: anime.stagger(50, { direction: 'reverse' })
                }, 800)
        },

        triggerItem(index) {
            clearInterval(this.animationInterval);
            this.animationInterval = null;
            this.animationCompleted = false;

            const _this = this;
            const animationPrevIndex = anime.timeline({
                easing: 'easeOutQuad',
            });

            animationPrevIndex
                .add({
                    targets: this.$refs.nav.querySelectorAll(`[data-nav-content] [data-nav-img]`),
                    opacity: 0,
                    rotate: '5deg',
                    duration: 400
                })
                .add({
                    targets: this.$refs.nav.querySelectorAll(`[data-nav-content] [data-nav-title]`),
                    opacity: 0,
                    translateY: '-100px',
                    duration: 400
                }, 0)

            const nextItem = this.$refs.nav.querySelector(`[data-nav-content="${index}"]`);
            const animationNextIndex = anime.timeline({
                easing: 'easeOutQuad',
                complete: function () {
                    setTimeout(() => {
                        _this.animationCompleted = true;
                    }, 100);
                }
            });

            animationNextIndex
                .add({
                    targets: nextItem.querySelector('[data-nav-img]'),
                    opacity: [0, 1],
                    rotate: ['-10deg', 0],
                    duration: 600
                }, 200)
                .add({
                    targets: nextItem.querySelector('[data-nav-title]'),
                    opacity: [0, 1],
                    translateY: ['100px', 0],
                    duration: 600
                }, 200)
        },

        enableBodyScrollLock() {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.body.style.overflow = "hidden";
            this.body.style.position = "fixed";
            this.body.style.top = `-${this.scrollTop}px`;
            this.body.style.width = "100%";
        },

        disableBodyScrollLock() {
            this.body.style.removeProperty("overflow");
            this.body.style.removeProperty("position");
            this.body.style.removeProperty("top");
            this.body.style.removeProperty("width");
            window.scrollTo(0, this.scrollTop);
        }
    }
}
</script>
